<app-navbar></app-navbar>

<section class="verify-page">
    <div class="verify-container">

        <div class="verify-heading">
            <mat-icon class="heading-icon">verified_user</mat-icon>
            <h1>{{ 'CERTIFICATE_VERIFY.TITLE' | translate }}</h1>
            <p>{{ 'CERTIFICATE_VERIFY.SUBTITLE' | translate }}</p>
        </div>

        <!-- busqueda manual por record locator -->
        <form class="verify-search" (ngSubmit)="onSearch()">
            <mat-form-field appearance="outline" class="search-field">
                <mat-label>{{ 'CERTIFICATE_VERIFY.CODE_LABEL' | translate }}</mat-label>
                <input matInput name="searchCode" [(ngModel)]="searchCode"
                       placeholder="AX-XXXXXXXX" autocomplete="off"/>
                <mat-icon matPrefix>qr_code_2</mat-icon>
            </mat-form-field>
            <button mat-raised-button color="primary" type="submit" [disabled]="!searchCode.trim()">
                <mat-icon>search</mat-icon>
                {{ 'CERTIFICATE_VERIFY.VERIFY' | translate }}
            </button>
        </form>

        @if (state === 'loading') {
            <div class="verify-card loading-card">
                <div class="spinner"></div>
                <span>{{ 'CERTIFICATE_VERIFY.LOADING' | translate }}</span>
            </div>
        }

        @if (state === 'not-found') {
            <div class="verify-card">
                <div class="status-banner status-invalid">
                    <mat-icon>gpp_bad</mat-icon>
                    <div>
                        <strong>{{ 'CERTIFICATE_VERIFY.NOT_FOUND' | translate }}</strong>
                        <span>{{ 'CERTIFICATE_VERIFY.NOT_FOUND_DESC' | translate }}</span>
                    </div>
                </div>
            </div>
        }

        @if (state === 'found' && certificate) {
            <div class="verify-card">
                <div class="status-banner" [ngClass]="certificate.valid ? 'status-valid' : 'status-expired'">
                    <mat-icon>{{ certificate.valid ? 'verified' : 'event_busy' }}</mat-icon>
                    <div>
                        <strong>{{ (certificate.valid ? 'CERTIFICATE_VERIFY.VALID' : 'CERTIFICATE_VERIFY.EXPIRED') | translate }}</strong>
                        <span>{{ (certificate.valid ? 'CERTIFICATE_VERIFY.VALID_DESC' : 'CERTIFICATE_VERIFY.EXPIRED_DESC') | translate }}</span>
                    </div>
                </div>

                <div class="certificate-body">
                    <span class="label-small">{{ 'CERTIFICATE_VERIFY.CERTIFIES' | translate }}</span>
                    <h2 class="student-name">{{ certificate.studentName }}</h2>
                    <span class="label-small">{{ 'CERTIFICATE_VERIFY.COMPLETED' | translate }}</span>
                    <h3 class="course-name">{{ certificate.courseName }}</h3>

                    <div class="details-grid">
                        <div class="detail">
                            <mat-icon>person</mat-icon>
                            <div>
                                <span class="detail-label">{{ 'CERTIFICATE_VERIFY.PROFESSOR' | translate }}</span>
                                <span class="detail-value">{{ certificate.teacherName || '-' }}</span>
                            </div>
                        </div>
                        <div class="detail">
                            <mat-icon>account_balance</mat-icon>
                            <div>
                                <span class="detail-label">{{ 'CERTIFICATE_VERIFY.ENTITY' | translate }}</span>
                                <span class="detail-value">{{ certificate.entityName || '-' }}</span>
                            </div>
                        </div>
                        <div class="detail">
                            <mat-icon>workspace_premium</mat-icon>
                            <div>
                                <span class="detail-label">{{ 'CERTIFICATE_VERIFY.CREDITS' | translate }}</span>
                                <span class="detail-value">{{ certificate.creditAmount ?? 0 }}</span>
                                @if (certificate.creditMessage) {
                                    <span class="detail-extra">{{ certificate.creditMessage }}</span>
                                }
                            </div>
                        </div>
                        <div class="detail">
                            <mat-icon>event_available</mat-icon>
                            <div>
                                <span class="detail-label">{{ 'CERTIFICATE_VERIFY.ISSUE_DATE' | translate }}</span>
                                <span class="detail-value">{{ certificate.certifyDate | date:'dd/MM/yyyy' }}</span>
                            </div>
                        </div>
                        <div class="detail">
                            <mat-icon [class.expired-icon]="!certificate.valid">event</mat-icon>
                            <div>
                                <span class="detail-label">{{ 'CERTIFICATE_VERIFY.EXPIRATION_DATE' | translate }}</span>
                                <span class="detail-value" [class.expired-text]="!certificate.valid">
                                    {{ certificate.expirationDate ? (certificate.expirationDate | date:'dd/MM/yyyy') : '-' }}
                                </span>
                            </div>
                        </div>
                        <div class="detail">
                            <mat-icon>qr_code_2</mat-icon>
                            <div>
                                <span class="detail-label">{{ 'CERTIFICATE_VERIFY.RECORD_LOCATOR' | translate }}</span>
                                <span class="detail-value code">{{ certificate.certifyCode }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="verify-footer">
                    <mat-icon>schedule</mat-icon>
                    {{ 'CERTIFICATE_VERIFY.CHECKED_ON' | translate }} {{ today | date:'dd/MM/yyyy HH:mm' }}
                </div>
            </div>
        }
    </div>
</section>

<app-footer></app-footer>
